import vihangaLogo from "../assets/images/AppNewLogo.png";
import talentSpotifyLogo from "../assets/images/appLogo3.png";

export const isVihangaBranding = () =>
  (window.location.href || "").toLowerCase().includes("vihanga");

export const getFallbackLogo = () =>
  isVihangaBranding() ? vihangaLogo : talentSpotifyLogo;
